import { GroupBase, StylesConfig } from "react-select";

import { grey } from "~/ui-kit/colors/colors";

import { SelectOption } from "./Select.types";

// TODO: Use variables instead of hard-coded values for font size and font weight
export const getCustomStyles = ({
  primaryColor,
}): StylesConfig<SelectOption, false, GroupBase<SelectOption>> => ({
  control: (styles, { isFocused }) => ({
    ...styles,
    minHeight: "2.5rem",
    borderColor: isFocused ? primaryColor : grey[200],
    borderRadius: "0.5rem",
    "&:hover": {
      borderColor: grey[500],
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: grey[800],
    fontSize: "0.875rem",
    fontWeight: 500,
  }),
  option: (styles, { data: { isDisabled }, isSelected }) => ({
    ...styles,
    fontSize: "0.875rem",
    fontWeight: 500,
    textAlign: "left",
    color: isSelected ? "white" : isDisabled ? grey[400] : grey[800],
    "&:active": {
      color: "white",
    },
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: grey[500],
    ":hover": {
      borderColor: grey[500],
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
});
